
const replacementList: [string[] | string, string][] = [
  [['°'], 'º'],
  [['¹', '₁'], '1'],
  [['²', '₂'], '2'],
  [['³', '₃'], '3'],
  [['⁴', '₄'], '4'],
  [['⁵', '₅'], '5'],
  [['⁶', '₆'], '6'],
  [['⁷', '₇'], '7'],
  [['⁸', '₈'], '8'],
  [['⁹', '₉'], '9'],
  [['⁰', '₀'], '0'],
  [['⁻','–','—','−'], '-'],

  // Spaces: 160 (non-breaking space), 5760 (word joiner), 8192-8202 (various spaces), 8239 (narrow no-break space), 8287 (medium mathematical space), 12288 (ideographic space
  [['\u00A0','\u1680','\u2000','\u2001','\u2002','\u2003','\u2004','\u2005','\u2006','\u2007','\u2008','\u2009','\u200A','\u202F','\u205F','\u3000'], ' '],
  // Quotes
  [['“','”','„','‟','❝','❞','〝','〞', '’'], '\''],
  [['“','”','‟','«','»','❝','❞','〝','〞'], '"'],

  // Math symbols
  [['×'], 'x'],
  [['÷'], '/'],
  [['±'], '+/-'],
  [['√'], 'sqrt'],
  [['•','‣','◦','▪','▫'], '\n* ']
];

const asciiMap: { [key: string]: string } = {};
replacementList.forEach(([chars, replacement]) => {
  if (Array.isArray(chars)) {
    chars.forEach((char) => {
      asciiMap[char] = replacement;
    });
  } else {
    asciiMap[chars] = replacement;
  }
});

const normalizeAscii = (input: string) => {
  const changes = [];
  let output = '';

  for (const char of input) {
      if (asciiMap[char]) {
        changes.push({original: char, replacement: asciiMap[char]});
        output += asciiMap[char];
      } else if (char.charCodeAt(0) > 127 && !Object.values(asciiMap).includes(char)) {
        changes.push({original: char, replacement: ''});
        // Skip non-ASCII characters
      } else {
        output += char;
      }
  }


  return {normalized: output, changes};
}

export class TextUtils {

  /**
   * Allow only 0-255 set of characters
   * @param text 
   */
  static onlyLatin(text: any) {
    
    if (!text) {
      return {normalized: '', changes: []};
    }

    //return text.replace(/[^\x00-\xFF]/g, '');
    return normalizeAscii(text);
  }

  /**
   * This method extract text from any string (i.e. HTML, Markdown, etc.)
   * We do this by:
   * - Extracting only [a-zA-Z'?¿] characters
   * - Removing any extra spaces
   * - Remove any directive (i.e. [AAA](BBB) -> AAA, [AAA](BBB)CCC -> AAACCC, anyText[AAA]{BBB}(CCC) -> AAA) 
   */
  static onlyText(text: string): string {
    if (!text) {
      return '';
    }
    // First, split the text by spaces for further processing
    const words = text.split(' ');

    // Then, we filter out any non-text characters, first, the directive characters
    
    const parsed = words.map((word) => {
      return removeDirectives(word);
    })
    .filter((word) => word.length > 0)
    .map(w => {
      return w.replace(/[^a-zA-Z'?¿]/g, '');
    }).map(w => {
      return w.replace(/\s/g, '');
    }).join(' ');

    return parsed;
  }
}

/**
 * Convert any:
 * - i.e. [AAA](BBB) -> AAA 
 * - [AAA](BBB)CCC -> AAACCC
 * - anyText[AAA]{BBB}(CCC) -> AAA
 * 
 * - We first test for the presence of a directive
 * @param word 
 */
function removeDirectives(word: string): string {
  if (!word) {
    return '';
  }

  // First, check if starts with something like :anything[AAA]{BBB}
  const directive = word.match(/:.*\[(.*)\].*/);
  if (directive) {
    return directive[1];
  }

  // Otherwise, check if it has something like [AAA](BBB){CCC}
  const directive2 = word.match(/\[(.*)\].*/);
  if (directive2) {
    return directive2[1];
  }

  // Return the word as is
  return word;
}
